import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "wage-insurance-single__row" }
const _hoisted_2 = { style: {"white-space":"pre-line"} }
const _hoisted_3 = ["checked", "disabled"]
const _hoisted_4 = { style: {"white-space":"pre-line"} }
const _hoisted_5 = ["id", "value", "readonly"]

import HomeWageTooltip from '@/components/wage/home/HomeWageTooltip.vue';
import { HOME_WAGE_DEDUCTION_FIX_CHECKBOX_TOOLTIP } from '@/policies';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeWageDeductionFixRow',
  props: {
    label: {},
    tooltip: {},
    fixed: { type: Boolean },
    displayValue: {},
    inputId: {},
    disabled: { type: Boolean },
    nameClass: {},
    fixCheckboxTooltip: { default: HOME_WAGE_DEDUCTION_FIX_CHECKBOX_TOOLTIP }
  },
  emits: ["toggle-fixed", "input-click", "input-focus", "input", "blur"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.tooltip)
      ? (_openBlock(), _createBlock(HomeWageTooltip, {
          key: 0,
          location: "top"
        }, {
          activator: _withCtx(({ props: tooltipProps }) => [
            _createElementVNode("span", _mergeProps(tooltipProps, {
              class: ["wage-insurance-single__name wage-insurance-single__name--tooltip", __props.nameClass]
            }), [
              _renderSlot(_ctx.$slots, "label", {}, () => [
                _createTextVNode(_toDisplayString(__props.label), 1)
              ])
            ], 16)
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(__props.tooltip), 1)
          ]),
          _: 3
        }))
      : (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(["wage-insurance-single__name", __props.nameClass])
        }, [
          _renderSlot(_ctx.$slots, "label", {}, () => [
            _createTextVNode(_toDisplayString(__props.label), 1)
          ])
        ], 2)),
    _createVNode(HomeWageTooltip, {
      location: "top",
      "member-visible": ""
    }, {
      activator: _withCtx(({ props: cbTip }) => [
        _createElementVNode("input", _mergeProps(cbTip, {
          type: "checkbox",
          class: "wage-insurance-single__fix-cb wage-insurance-single__fix-cb--tooltip",
          checked: __props.fixed,
          disabled: __props.disabled,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle-fixed', ($event.target as HTMLInputElement).checked)))
        }), null, 16, _hoisted_3)
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.fixCheckboxTooltip), 1)
      ]),
      _: 1
    }),
    _createElementVNode("input", {
      id: __props.inputId,
      type: "text",
      class: _normalizeClass(["wage-payroll-grid__input", {
        'wage-payroll-grid__input--readonly': __props.fixed && !__props.disabled,
      }]),
      value: __props.displayValue,
      readonly: __props.disabled || __props.fixed,
      inputmode: "numeric",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('input-click'))),
      onFocus: _cache[2] || (_cache[2] = ($event: any) => (emit('input-focus', $event))),
      onInput: _cache[3] || (_cache[3] = ($event: any) => (emit('input', $event))),
      onBlur: _cache[4] || (_cache[4] = ($event: any) => (emit('blur'))),
      onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (($event.target as HTMLInputElement).blur()), ["enter"]))
    }, null, 42, _hoisted_5)
  ]))
}
}

})